import { useEffect, useRef } from "react";

export default function BackToTop() {
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    let rafId: number;

    const update = () => {
      if (!btnRef.current) return;
      const visible = window.scrollY > 300;
      btnRef.current.style.opacity = visible ? "1" : "0";
      btnRef.current.style.pointerEvents = visible ? "auto" : "none";
      btnRef.current.style.transform = visible ? "translateY(0)" : "translateY(12px)";
    };

    const onScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(rafId);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      ref={btnRef}
      onClick={handleClick}
      aria-label="Back to top"
      className="fixed bottom-8 right-8 z-[9998] w-10 h-10 flex items-center justify-center rounded-full cursor-pointer whitespace-nowrap"
      style={{
        opacity: 0,
        pointerEvents: "none",
        transform: "translateY(12px)",
        transition: "opacity 0.35s ease, transform 0.35s ease",
        background: "rgba(212,168,83,0.12)",
        border: "1px solid rgba(212,168,83,0.35)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        color: "#D4A853",
      }}
    >
      <i className="ri-arrow-up-line" style={{ fontSize: "16px" }} />
    </button>
  );
}
